import { render, staticRenderFns } from "./MemberTextTab.vue?vue&type=template&id=60e985eb&"
import script from "./MemberTextTab.vue?vue&type=script&lang=js&"
export * from "./MemberTextTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports